import { jsx as t, jsxs as l } from "react/jsx-runtime";
import "react";
var r = (i) => /* @__PURE__ */ l("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...i,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1660 -16)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0.000244141H0V19.9998H20V0.000244141Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V6.66652H20V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 13.3335H0V20H20V13.3335Z",
      fill: "#FF9811"
    })
  ]
});
export {
  r as default
};
